import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installAuthGuard } from './services/authGuard';

// Before anything renders, so the very first request of the session is covered too --
// a page load with an already-expired token would otherwise fail silently on mount.
installAuthGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
